import './GoldRateDropdown.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const GoldRateDropdown = () => {
  const [prices, setPrices] = useState({ gold: null, silver: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const localResponse = await axios.get(
          'https://www.dhanapaljewellery.com/api/v1/rates',
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        const rates = localResponse.data;

        if (Array.isArray(rates) && rates.length > 0) {
          const latestRate = rates.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )[0];

          setPrices({
            gold: parseFloat(latestRate.goldRate),
            silver: parseFloat(latestRate.silverRate),
          });
        } else {
          throw new Error('No rates available in local database');
        }
      } catch (localErr) {
        console.warn('Local rate fetch failed:', localErr.message);

        try {
          const response = await axios.get(
            'https://jerwishtech.site/v1/api/account/todayrate'
          );

          setPrices({
            gold: parseFloat(response.data.Rate),
            silver: parseFloat(response.data.SILVERRATE),
          });
        } catch (fallbackErr) {
          console.error('Fallback API also failed:', fallbackErr.message);
          setError('Failed to fetch gold rate.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="dropdown-container">
      <div className="dropdown">
        <button
          className="dropdown-toggle"
          style={{
            background: 'linear-gradient(135deg, #FFD700, #FFA500)',
            color: '#000',
            transition: '0.3s',
          }}
        >
          <span>GOLD 1G: ₹{prices.gold}</span>
        </button>
      </div>
    </div>
  );
};

export default GoldRateDropdown;
